import dayjs from 'dayjs'
import releaseUpdates from '../../../releaseNotes/releaseNotes.json'
import GeometricForm from '../../assets/geometric_form.svg'
import styles from './ReleaseUpdates.module.css'

const ReleaseUpdates = () => {
  const formatDate = (date: string) => {
    const month = dayjs(date).local().format('MMMM')
    if (month.length > 5) {
      return month.slice(0, 3) + ' ' + dayjs(date).local().format('D, YYYY')
    }
    return dayjs(date).local().format('MMMM D, YYYY')
  }

  return (
    <div className={styles.releaseUpdatesContainer}>
      <div className={styles.header}>
        <div className={styles.headerTitle}>
          <h1>Release Updates</h1>
          <p>Check out the latest releases, enhancements and updates to see what’s new.</p>
        </div>
        <img
          src={GeometricForm}
          alt="Geometric Form"
        />
      </div>
      <div className={styles.content}>
        {releaseUpdates.map(release => (
          <div
            className={styles.releaseContainer}
            key={release.version}>
            <div className={styles.releaseDateAndVersion}>
              <p className={styles.releaseDate}>{formatDate(release.date)}</p>
              <p className={styles.releaseVersion}>{release.version}</p>
            </div>
            <div className={styles.releaseFeatures}>
              {release.features.map(feature => (
                <div
                  className={styles.releaseFeature}
                  key={feature.feature_title}>
                  <p className={styles.releaseFeatureTitle}>{feature.feature_title}</p>
                  <p className={styles.releaseFeatureSummary}>{feature.summary}</p>
                  <ul>
                    {feature.details.map(detail => (
                      <li
                        key={detail}
                        className={styles.releaseFeatureSummary}>
                        {detail}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ReleaseUpdates
